import React, { useState, useEffect, useRef, useCallback } from "react";
import "./css/Signup.css";
import SS from "./images/login/ss_Logo.png";
import Info from "./images/icons/info.png";
import ErrorInfo from "./images/icons/infoRed.png";
import Img from "./images/login/Group 84421.png";
import "@fontsource/josefin-sans";
import "@fontsource/josefin-sans/400.css";
import "@fontsource/josefin-sans/400-italic.css";
import CryptoJS from "crypto-js";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
// import firebase from './js/firebase.config'
// import { auth } from './js/firebase.config';
import PasswordIndicator from "./PasswordIndicator";
import ReactFlagsSelect from "react-flags-select";
import Select from "react-select";
import axios from "axios";
import check from "./images/icons/check-mark.png";
import io from "socket.io-client";
import WorldCountries from "world-countries";
import CountriesData from "./js/countries+states+cities.json";

function Signup({ placeholder, defaultValue, onChange }) {
	const location = useLocation(null);

	const [infos, setInfos] = useState({ email: "" });
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState({ email: "" });

	const validateEmail = (email) => {
		const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return re.test(String(email).toLowerCase());
	};

	const api_base_url = process.env.REACT_APP_API_BASE_URL;
	// const domain = 'http://192.168.0.187:8010'
	// const domain = "http://localhost:3000";
	const domain = 'https://sherdine.shersoftware.com'

	const handleChangeFields = (e, fieldName) => {
		const value = e.target.value;

		// Set the email value in the state
		setInfo({ ...info, [fieldName]: value });

		// if (!validateEmail(value)) {
		//     setErrors({ ...errors, email: 'Invalid email address' });
		// } else {
		//     setErrors({ ...errors, email: '' });
		// }

		if (validateEmail(value)) {
			setErrors({ ...errors, email: "" });
		} else {
			setErrors({ ...errors, email: "Invalid email" });
		}
	};
	const navigate = useNavigate(null);

	const handleLogin = () => {
		navigate("/");
	};

	const [acceptTerms, setAcceptTerms] = useState(false);

	const handleCheck = (e) => {
		setAcceptTerms(e.target.checked);
	};

	const [info, setInfo] = useState({});


	const [password, setPassword] = useState();
	const handleChangeField = (e, fieldName) => {
		const value = e.target.value;
		if (fieldName === "confirmPass") {
			setPassword(value);
			setOtp(value);
		} else {
			setInfo((prev) => ({
				...prev,
				[fieldName]: value,
			}));
		}
	};

	const generateOTP = () => {
		return Math.floor(100000 + Math.random() * 900000);
		// return Math.floor(1 + 1);
	};

	const [id, setId] = useState();

	const [error, setError] = useState(false);

	const handlePassError = () => {
		const hasError = password !== info.password;
		if (error !== hasError) {
			setError(hasError); // Update only if the value has changed
		}
	};

	useEffect(() => {
		handlePassError();
	}, [password, info.password]);

	const handleChangeFieldNum = (e, fieldName) => {
		const value = e.target.value;

		// If the field should be a number, convert it
		if (fieldName === "mobileNum" || fieldName === "pincode") {
			// || fieldName === 'pincode'
			setInfo({
				...info,
				[fieldName]: parseInt(value, 10) || "", // Convert to number or keep it as empty if input is not valid
			});
		} else {
			setInfo({
				...info,
				[fieldName]: value,
			});
		}
	};

	const sendOtp = async () => {
		// if (!emailVerified) {
		//   return toast.error("Verify email!",
		//      {
		//     className: "custom-toast",
		//     bodyClassName: "custom-toast-container",
		//     closeButtonClassName: "custom-toast-close-button",
		//     onClose: () => {},
		//   });
		// }

		// toast.dismiss();

		//(nonEmptyFieldCount);

		if (acceptTerms && nonEmptyFieldCount >= 9 && password == info.password) {
			const otp = generateOTP();
			const dataInfo = {
				otp: otp,
				name: info.name,
				companyName: info.companyName,
				email: info.email,
				mobileNum: info.mobileNum, // Convert string to number
				state: info.state,
				country: info.country,
				city: info.city,
				password: info.password,
				pincode: info.pincode,
			};

			// //(dataInfo);

			try {
				setLoading(true);
				const response = await fetch(`${api_base_url}/send`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(dataInfo),
				});

				// const data = await response.json();
				if (response.status === 409) {
					setLoading(false);
					toast.error("User already exists", {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
				} else if (response.ok) {
					setLoading(false);
					toast.success("OTP successully send to ********55", {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
					navigate("/AuthSign", {
						state: dataInfo,
					});
				}

				// if (!response.ok) {
				//     throw new Error('Error sending OTP');
				// }
				// return true
				// // //('OTP sent successfully');
			} catch (error) {
				setLoading(false);
				console.error("Error sending OTP:", error);
			}
		} else if (nonEmptyFieldCount < 9) {

			// alert("Fill the required fields!")
			toast.error("Fill all the fields!", {
				className: "custom-toast-error",
				bodyClassName: "custom-toast-error-container",
				closeButtonClassName: "custom-toast-error-close-button",
				onClose: () => { },
			});
		} else if (!validateEmail(info.email)) {
			toast.error("Invalid email address!", {
				className: "custom-toast-error",
				bodyClassName: "custom-toast-error-container",
				closeButtonClassName: "custom-toast-error-close-button",
			});
			return;
		} else if (password !== info.password) {
			// alert("Password didn't match!")
			toast.error("Password didn't match!", {
				className: "custom-toast-error",
				bodyClassName: "custom-toast-error-container",
				closeButtonClassName: "custom-toast-error-close-button",
				onClose: () => { },
			});
			setError(true);
		} else if (password === "" && info.password === "") {
			toast.error("Password can not be Empty!", {
				className: "custom-toast-error",
				bodyClassName: "custom-toast-error-container",
				closeButtonClassName: "custom-toast-error-close-button",
				onClose: () => { },
			});
			setError(true);
		} else if (!acceptTerms) {
			// alert("Please accept terms and condition!")
			toast.error("Please accept terms and condition!", {
				className: "custom-toast-error",
				bodyClassName: "custom-toast-error-container",
				closeButtonClassName: "custom-toast-error-close-button",
				onClose: () => { },
			});
		}
	};
	const nonEmptyFieldCount = Object.keys(info).filter(
		(key) => info[key] !== null && info[key] !== "" && info[key] !== undefined
	).length;

	// const [passLabel, setPassLabel] = useState({
	//     label: '',
	//     color: ''
	// })

	const [user, setUser] = useState(null);
	const [otp, setOtp] = useState("");
	// const [phone, setPhone] = useState("+918075993864");
	const [phone, setPhone] = useState("+918590863400");

	const [selected, setSelected] = useState("");
	const [selectedStates, setSelectedStates] = useState([]);

	const customMDpx = window.innerWidth >= 768;

	// //(customMDpx);

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			width: "100%",
			fontSize: ".9em",
			textAlign: "left",
			backgroundColor: state.isSelected ? "#c8cbcf" : "#FFF",
			backgroundColor: state.isFocused ? "#c8cbcf" : "#FFF",
			color: state.isFocused ? "#000" : "#000",
			":active": {
				...provided[":active"],
				backgroundColor: "#c8cbcf",
			},
		}),
		control: (provided, state) => ({
			...provided,
			height: `${customMDpx ? "2.15rem" : "2.5rem"}`,
			minHeight: `${customMDpx ? "2rem" : "2.5rem"}`,
			fontSize: ".9em",
			borderRadius: `${customMDpx ? ".313rem" : ".626rem"}`, // Adjust this value as needed
			padding: "0", // Ensure no extra padding is added
			border: `${customMDpx ? "1px solid #ccc" : "none"}`,
			boxShadow: `${customMDpx ? "" : "2px 5px 10px rgba(0, 0, 0,.15)"}`,
			"&:hover": {
				border: "1px solid #DFDFDF",
			},
		}),
		menuPortal: (base) => ({
			...base,
			zIndex: 9999, // Ensure it's above other elements
		}),
		valueContainer: (provided) => ({
			...provided,
			height: `${customMDpx ? "2.15rem" : "2.5rem"}`,
			minHeight: `${customMDpx ? "2rem" : "2.5rem"}`,
			padding: "0 8px",
			display: "flex",
			alignItems: "center",
			fontSize: ".85rem",
		}),
		input: (provided) => ({
			...provided,
			height: `${customMDpx ? "2.15rem" : "2.5rem"}`,
			minHeight: `${customMDpx ? "2rem" : "2.5rem"}`,
			margin: "0",
			padding: "0",
			fontSize: ".9rem",
		}),
		indicatorsContainer: (provided) => ({
			...provided,
			height: `${customMDpx ? "2.15rem" : "2.5rem"}`,
			display: "flex",
			alignItems: "center",
		}),
		dropdownIndicator: (provided) => ({
			...provided,
			padding: "0", // Remove padding to center the icon
			width: "1rem",
		}),
		placeholder: (provided) => ({
			...provided,
			margin: "0", // Remove margin to center the text
		}),
	};

	// useEffect(() => {
	//     if (selected !== "") {
	//     const country = StatesCities.find(country => country.iso3 === selected);
	//     setSelectedStates(country ? country.states : []);
	//     }
	// }, [selected]);

	// Build a flag map from world-countries (cca3 -> flag emoji)
	const flagMap = {};
	WorldCountries.forEach((wc) => {
		flagMap[wc.cca3] = wc.flag || "";
	});

	// Use local JSON (has iso3 + states) for the dropdown
	const formattedCountries = CountriesData.map((country) => {
		// Match flag by country name from world-countries
		const wcMatch = WorldCountries.find(
			(wc) => wc.name.common === country.name || wc.cca3 === country.iso3
		);
		const flag = wcMatch ? wcMatch.flag : "";
		return {
			value: country.iso3, // use iso3 so lookups work
			label: `${flag} ${country.name}`,
			name: country.name,
			emoji: flag,
		};
	});

	const handleCountry = (selectedCountry, fieldName) => {
		if (info.city) {
			info.city = "";
		}
		setSelected(selectedCountry);
		setSelectStateOption("");
		setSelectOptionCity("");
		setSelectedCities([]);

		// Use local JSON (iso3 field) for country + states lookup
		const country = CountriesData.find((item) => item.iso3 === selectedCountry);
		const countryName = country?.name;

		setInfo((prev) => ({
			...prev,
			[fieldName]: countryName,
		}));

		if (country && Array.isArray(country.states)) {
			const stateOptions = country.states.map((state) => ({
				value: state.state_code,
				label: state.name,
			}));
			setSelectedStates(stateOptions);
		} else {
			setSelectedStates([]);
		}
	};

	const [selectStateOption, setSelectStateOption] = useState("");
	const [selectedCities, setSelectedCities] = useState([]);
	const handleChangeState = (state, fieldName) => {
		//(state);
		// console.log(e.target.value);


		if (info.city) {
			info.city = "";
		}
		setSelectStateOption(state);

		// Find the country based on `selected` (iso3) in local JSON
		const country = CountriesData.find((item) => item.iso3 === selected);

		if (country && Array.isArray(country.states)) {
			//     // Find the selected state      

			const selectedState = country.states.find(
				(item) => item.name === state.label
			);
			const stateName = selectedState.name;
			setInfo((prev) => ({
				...prev,
				[fieldName]: stateName,
			}));
		}
	};

	const [selectOptionCity, setSelectOptionCity] = useState("");
	const handleChangeCity = (city, fieldName) => {
		setSelectOptionCity(city);
		setInfo((prev) => ({
			...prev,
			[fieldName]: city,
		}));
	};

	const [isHovered, setIsHovered] = useState(false);

	const [passLabel, setPassLabel] = useState({ label: "", color: "" });

	const handlePassLabelColor = useCallback((label, color) => {
		setPassLabel((prev) => ({
			...prev,
			label,
			color,
		}));
	}, []);

	const currentTime = Date.now();

	// Save query parameters and handle new tab closure
	useEffect(() => {
		localStorage.setItem("redirect", "false");

		const redirect = localStorage.getItem("redirect");

		const queryParams = new URLSearchParams(location.search);
		if (queryParams) {
			const email = queryParams.get("e");
			const encryptedBody = queryParams.get("c");
			const expirationTime = parseInt(queryParams.get("expires"), 10);

			// Redirect to /signup if any query parameter is missing
			if (
				!email ||
				!encryptedBody ||
				!expirationTime ||
				encryptedBody === "undefined"
			) {
				localStorage.removeItem("signupRedirectData");
				localStorage.removeItem("signupTrigger");
				localStorage.removeItem("valid");
				navigate("/signup", { replace: true });
				return;
			}

			// // Handle malformed or undefined encryptedBody
			// if (!encryptedBody || encryptedBody === "undefined") {
			//     localStorage.removeItem('signupRedirectData');
			//     localStorage.removeItem('signupTrigger');
			//     localStorage.removeItem('valid');
			//     navigate('/signup', { replace: true });
			// }

			if (email && encryptedBody && expirationTime) {
				// Store the query params in localStorage
				localStorage.setItem(
					"signupRedirectData",
					JSON.stringify({ email, encryptedBody, expirationTime })
				);

				// Notify other tabs to handle navigation
				localStorage.setItem("signupTrigger", Date.now());
				// Try to close this window (might fail if opened from certain contexts)
				if (redirect) {
					window.close();
				}
			}
		}
	}, [location.search]);

	// Handle incoming storage event
	useEffect(() => {
		const handleStorageChange = (event) => {
			//(event);

			if (event.key === "signupTrigger") {
				try {
					const rawData = localStorage.getItem("signupRedirectData");

					// Check for data existence and parse it safely
					if (rawData) {
						const data = JSON.parse(rawData);

						if (
							data &&
							data.email &&
							data.encryptedBody &&
							data.expirationTime
						) {
							navigate(
								`/signup?e=${encodeURIComponent(
									data.email
								)}&c=${encodeURIComponent(
									data.encryptedBody
								)}&expires=${encodeURIComponent(data.expirationTime)}`,
								{ replace: true }
							);
						}

						// Cleanup after navigation
						localStorage.removeItem("signupRedirectData");
						localStorage.removeItem("signupTrigger");
					}
				} catch (error) {
					console.error(
						"Error parsing signupRedirectData or handling navigation:",
						error
					);
				}
			}
		};

		window.addEventListener("storage", handleStorageChange);

		return () => {
			window.removeEventListener("storage", handleStorageChange);
		};
	}, [navigate]);

	const [emailVerified, setEmailVerified] = useState(true);

	const [linkExpired, setLinkExpired] = useState(true);

	const queryParams = new URLSearchParams(location.search);

	useEffect(() => {
		if (queryParams.size > 0) {
			const expirationTime = parseInt(queryParams.get("expires"), 10);

			if (isNaN(expirationTime) || currentTime > expirationTime) {
				setLinkExpired(true);
				// Link has expired
				Swal.fire({
					html: `
                    <p style="font-size: 25px; color: #555;">
                        <b>Link Expired!</b>
                    </p>
                `,
					background: "#f9f9f9",
					icon: "warning",
					iconColor: "#c30000",
					confirmButtonText: "OK",
					confirmButtonColor: "#c30000",
					background: "#f9f9f9",
					allowOutsideClick: true,
					allowEscapeKey: true,
				}).then((result) => {
					// Check if the user clicked "OK" or closed the modal
					if (
						result.isConfirmed ||
						result.dismiss === Swal.DismissReason.backdrop ||
						result.dismiss === Swal.DismissReason.esc
					) {
						navigate("/signup");
					}
					navigate("/signup");
				});
			} else {
				const valid = localStorage.getItem("valid");

				console.log(valid, "valid");


				if (!valid) {
					handleEmailVerified();
					localStorage.setItem("valid", "true");
				}

				setEmailVerified(true);
				setLinkExpired(false);

				const encryptedBody = queryParams.get("c");

				const secretKey = "encryptcredentials";

				if (encryptedBody) {
					// Decode the URL-safe encrypted body first
					const decodedEncryptedBody = decodeURIComponent(encryptedBody);

					// Decrypt the body
					const bytes = CryptoJS.AES.decrypt(decodedEncryptedBody, secretKey);
					const decryptedBody = bytes.toString(CryptoJS.enc.Utf8);

					// Check if the decrypted body is a valid string
					if (decryptedBody) {
						try {
							// Parse the decrypted body as JSON
							const body = JSON.parse(decryptedBody);
							//(body);

							const countryObj = CountriesData.find(
								(country) => country.name === body.country
							);
							// Use iso3 since handleCountry matches by iso3
							const Abb = countryObj ? countryObj.iso3 : "";

							setInfo({
								...body,
								confirmPass: body.password,
							});

							handleCountry(Abb, "country");

							setPassword(body.password);

							setSelectStateOption({ value: "", label: body.state });
						} catch (error) {
							console.error("Error parsing decrypted body:", error);
						}
					} else {
						console.error("Decrypted body is empty or invalid");
					}
				}
			}
		} else {
			// setEmailVerified(false);
			setLinkExpired(false);
		}
	}, [location]);

	const handleEmailVerified = async () => {
		await Swal.fire({
			html: `
            <p style="font-size: 25px; color: #555;">
                <b>Email Verified!</b>
            </p>
        `,
			background: "#f9f9f9", // Custom background color
			customClass: {
				popup: "custom-popup", // Custom class for the popup (can style in CSS)
				confirmButton: "custom-confirm-btn", // Custom class for confirm button
				cancelButton: "custom-cancel-btn", // Custom class for cancel button
			},
			icon: "success",
			confirmButtonText: "OK",
			confirmButtonColor: "#4CAF50",
			background: "#f9f9f9",
			allowOutsideClick: true,
			allowEscapeKey: true,
		});

		// setEmailVerified(true)
		// setLinkExpired(false)
	};

	// useEffect(() => {
	//     // Connect to the WebSocket server
	//     const socket = io(api_base_url);
	//     socket.on('emailVerified', () => {
	//         handleEmailVerified();
	//     });

	//     return () => {
	//         socket.disconnect();
	//     };
	// },[])

	const handleVerfiyEmail = async () => {
		if (errors.email !== "verify") return;

		const expiryTime = Date.now() + 3600000;

		try {
			const response = await axios.post(
				`${api_base_url}/sendVerificationEmail`,
				{
					domain,
					expiryTime,
					info,
				}
			);



			if (response.status === 200) {
				toast.success(`Verfication link send to ${info.email}!`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
				localStorage.setItem("redirect", "false");
			} else {
				alert("error occured in sendVerificationEmail");
			}
		} catch (error) {
			//(error);
		}
	};

	return (
		<div
			className={`${linkExpired ? "hidden" : "w-screen h-screen flex overflow-hidden relative"
				}`}
		>
			{loading && (
				<div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
					<div className="bg-white px-6 py-8 rounded-lg shadow-xl text-center flex flex-col items-center justify-center gap-3 z-50">
						<div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-[#0008B4]"></div>
						<div className="text-lg font-semibold text-[#0008B4] px-4">
							Sending OTP, please wait...
						</div>
					</div>
				</div>
			)}
			<div className="w-full h-full flex flex-col zero:py-5 md:px-20 md:py-10 overflow-hidden">
				<div className="w-full h-[10%] zero:px-8 zero:pb-2 md:p-0 flex zero:items-end zero:justify-end md:items-center md:justify-start">
					<div className="w-full flex justify-start items-center gap-1">
						<img className="w-[1rem]" src={SS} alt="" />
						<span
							className="text-2xl font-semibold text-[#0008B4]"
							style={{ fontFamily: "Times New Roman" }}
						>
							SherDine
						</span>
					</div>
				</div>
				<div className="w-full h-[90%] md:flex md:flex-row gap-2 overflow-hidden">
					<div className="hidden w-full md:w-1/2 md:flex h-full justify-start items-center">
						<img className="h-full min-w-0 max-w-full" src={Img} alt="" />
					</div>
					<div className="w-full md:w-1/2 h-full flex flex-col font-nunito md:font-josefin overflow-hidden">
						<div className="Signup_Contents_InfoDiv_Title h-max zero:px-8 md:px-0 pb-3">
							<span className="Signup_Contents_InfoDiv_Title_Head">
								Create an account
							</span>
							<span className="Signup_Contents_InfoDiv_Title_smallLogin">
								Already have an account ?{" "}
								<span onClick={handleLogin}>Login</span>
							</span>
						</div>
						<div className="w-full flex flex-col zero:gap-3 md:gap-2 flex-1 min-h-0 zero:px-8 zero:pb-3 md:pl-1 md:pr-2 md:py-1 md:shadow-[1px_1px_25px_rgba(0,0,0,0.1)] overflow-auto noScroll md:customScroll">
							<div className="w-full  zero:flex zero:flex-col gap-3 md:flex md:flex-row">
								<div className="w-full flex flex-col gap-1">
									<span className="zero:text-[#6D6D6D] md:text-[#000]">
										Name
									</span>
									<input
										type="text"
										className="w-full px-2 zero:py-2 md:py-1 zero:border-0 md:border zero:shadow-[2px_5px_10px_rgba(0,0,0,0.15)] md:shadow-none zero:rounded-[.626rem] md:rounded-[.313rem]"
										value={info.name}
										onChange={(e) => handleChangeField(e, "name")}
									/>
								</div>
								<div className="w-full flex flex-col gap-1">
									<span className="zero:text-[#6D6D6D] md:text-[#000]">
										Company Name
									</span>
									<input
										type="email"
										className="w-full px-2 zero:py-2 md:py-1 zero:border-0 md:border zero:shadow-[2px_5px_10px_rgba(0,0,0,0.15)] md:shadow-none zero:rounded-[.626rem] md:rounded-[.313rem]"
										value={info.companyName}
										onChange={(e) => handleChangeField(e, "companyName")}
									/>
								</div>
							</div>
							<div className="w-full  zero:flex zero:flex-col gap-3 md:flex md:flex-row">
								<div className="w-full flex flex-col gap-1">
									<div className="flex w-full zero:text-[#6D6D6D] md:text-[#000]">
										<span className="w-full">Email</span>
										{emailVerified ? (
											<div className="w-max flex justify-center items-center">
												{/* <img className="w-[1rem]" src={check} alt="" /> */}
											</div>
										) : (
											errors.email && (
												<span
													className={`w-max text-nowrap text-[.9rem] ${errors.email === ""
														? "text-[#0008B4] underline cursor-pointer"
														: "text-[#000] opacity-75"
														}`}
												// onClick={handleVerfiyEmail}
												>
													{errors.email}
												</span>
											)
										)}
									</div>
									<input
										type="email"
										className="w-full px-2 zero:py-2 md:py-1 zero:border-0 md:border zero:shadow-[2px_5px_10px_rgba(0,0,0,0.15)] md:shadow-none zero:rounded-[.626rem] md:rounded-[.313rem]"
										required
										value={info.email}
										onChange={(e) => handleChangeFields(e, "email")}
									/>
								</div>
								<div className="w-full flex flex-col gap-1 searchable">
									<span className="zero:text-[#6D6D6D] md:text-[#000]">
										Country
									</span>
									{/* <ReactFlagsSelect
                                    selected={selected}
                                    onSelect={(code) => handleCountry(code, 'country')}
                                    searchable
                                    // className='w-full h-full'
                                /> */}
									{/* AF country 123 */}


									<Select
										options={formattedCountries}
										placeholder={placeholder}
										defaultValue={formattedCountries.find(
											(c) => c.value === defaultValue
										)}
										onChange={(selected) => {
											if (selected) {
												handleCountry(selected.value, "country");
											}
										}}
										className="text-black"
									/>

								</div>
							</div>
							<div className="w-full zero:flex zero:flex-col gap-3 md:flex md:flex-row">
								<div className="w-full flex flex-col gap-1">
									<span className="zero:text-[#6D6D6D] md:text-[#000]">
										State
									</span>
									<Select
										value={selectStateOption}
										onChange={(state) => handleChangeState(state, "state")}
										options={selectedStates}
										placeholder="Select state"
										styles={customStyles}
										menuPortalTarget={document.body} // Render the dropdown in the body
										menuPosition="fixed" // Use fixed positioning
									/>
								</div>
								<div className="w-full flex flex-col gap-1">
									<span className="zero:text-[#6D6D6D] md:text-[#000]">
										City
									</span>
									<input
										type="text"
										className="w-full px-2 zero:py-2 md:py-1 zero:border-0 md:border zero:shadow-[2px_5px_10px_rgba(0,0,0,0.15)] md:shadow-none zero:rounded-[.626rem] md:rounded-[.313rem]"
										value={info.city}
										onChange={(e) => handleChangeField(e, "city")}
									/>
								</div>
							</div>
							<div className="w-full zero:flex zero:flex-col gap-3 md:flex md:flex-row">
								<div className="w-full flex flex-col gap-1">
									<span className="zero:text-[#6D6D6D] md:text-[#000]">
										Mobile Number
									</span>
									<input
										type="number"
										className="text-left w-full px-2 zero:py-2 md:py-1 zero:border-0 md:border zero:shadow-[2px_5px_10px_rgba(0,0,0,0.15)] md:shadow-none zero:rounded-[.626rem] md:rounded-[.313rem]"
										value={info.mobileNum}
										onChange={(e) => handleChangeFieldNum(e, "mobileNum")}
									/>
								</div>
								<div className="w-full flex flex-col gap-1">
									<span className="zero:text-[#6D6D6D] md:text-[#000]">
										Pincode
									</span>
									<input
										type="number"
										className="text-left w-full px-2 zero:py-2 md:py-1 zero:border-0 md:border zero:shadow-[2px_5px_10px_rgba(0,0,0,0.15)] md:shadow-none zero:rounded-[.626rem] md:rounded-[.313rem]"
										value={info.pincode}
										onChange={(e) => handleChangeFieldNum(e, "pincode")}
									/>
								</div>
							</div>
							<div className="w-full zero:flex zero:flex-col gap-3 md:flex md:flex-row">
								<div className="w-full flex flex-col gap-1">
									<div className="Signup_Contents_InfoDiv_Contents_Info_SpanInputPasswordDiv">
										<span className="w-1/2 zero:text-[#6D6D6D] md:text-[#000]">
											Password
										</span>
										<span
											className="w-1/2 text-right flex justify-end items-center text-[.75rem]"
											style={{ color: passLabel.color }}
										>
											{info.password ? passLabel.label : ""}
										</span>
									</div>
									<div className="w-full zero:border-0 md:border borderTypeOnly zero:shadow-[2px_5px_10px_rgba(0,0,0,0.15)] md:shadow-none zero:rounded-[.626rem] md:rounded-[.313rem]">
										<input
											type="password"
											className="w-full border-none px-2 md:py-1 zero:py-2"
											value={info.password || ""}
											onChange={(e) => handleChangeField(e, "password")}
										/>
										<PasswordIndicator
											password={info.password}
											passLabelColor={handlePassLabelColor}
										/>
									</div>
								</div>
								<div className="w-full flex flex-col gap-1">
									<span className="w-full text-left zero:text-[#6D6D6D] md:text-[#000]">
										Confirm Password
									</span>
									<div className="w-full flex zero:border-0 md:border borderTypeOnly zero:shadow-[2px_5px_10px_rgba(0,0,0,0.15)] md:shadow-none zero:rounded-[.626rem] md:rounded-[.313rem]">
										<input
											type="password"
											className="w-full border-none px-2 md:py-1 zero:py-2"
											value={info.confirmPass}
											onChange={(e) => handleChangeField(e, "confirmPass")}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="w-full h-max flex flex-col gap-2 zero:px-8 md:px-0 zero:pb-3 md:pb-0 pt-3">
							<div className="Signup_Contents_InfoDiv_Terms">
								<div className="Signup_Contents_InfoDiv_Terms_CheckBox">
									<input
										type="checkbox"
										checked={acceptTerms}
										onChange={handleCheck}
									/>
								</div>
								<span className="Signup_Contents_InfoDiv_TermsSpan">
									Agree to our <span>Terms & Condition</span> Visitor Agreement
									and Privacy Policy.
								</span>
							</div>
							<button
								className="w-full bg-[#0008B4] rounded-[.626rem] text-[#fff] p-2 text-[1rem] font-josefin"
								onClick={sendOtp}
							>
								Sign up
							</button>
						</div>
						<div id="recaptcha" style={{ border: "none" }}></div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Signup;
